<template>
  <span class="badge w-fit font-semibold" :class="PO_STATUS_TONE[status]">{{ statusLabel(status) }}</span>
</template>

<script setup lang="ts">
  import { PO_STATUS_TONE } from '@/components/poTracker/poTrackerStyles';
  import type { PoStatus } from '@/types/poTracker';
  import { statusLabel } from '@/utils/poTracker';

  defineProps<{ status: PoStatus }>();
</script>
